module.exports = __webpack_public_path__ + "img/制糖行业结构示意图.ccd1e18e.jpg";